import * as angular from 'angular';

import { IRequestService } from '../../services';

export interface IPerformanceService {
    getEnvironment(): angular.IPromise<any>;
}

export class PerformanceService implements IPerformanceService {
    static serviceId = 'performanceService';

    static $inject = ['requestService'];

    constructor(private _requestService: IRequestService) {
    }

    getEnvironment(): angular.IPromise<any> {
        const url = this._requestService.getUrlV1() + 'performance/';
        this._requestService.cleanCache(url);
        return this._requestService.get(url);
    }
}
